export const getHolidaysInitState = {
	holidays: null,
	error: null,
	errorShow: false,
	loading: false,
};
